//#region Imports
import React, { useEffect, useState } from 'react';
import { Backdrop, CircularProgress, Typography, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import excel from '../../../images/excel.png';
import pdf from '../../../images/pdf.png';
import { internalIconStyles, tableStyle } from '../../../style/common';
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from '../../../images/pitc.png';
import eOpsLogo from '../../../images/eops.png';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import "../../../style/common.scss";
import BasicTable from '../../../components/basicTable/basicTable';
import { cfpBaseUrl } from '../../../network/urls';
//#endregion

const APMSEscalatedComplaints = () => {

    const { code, token, hierarchy } = useSelector((state) => state.auth);
    const companyCode = code.slice(0, 2);

    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [apmsComplaints, setApmsComplaints] = useState([]);
    const [dataGrid, setDataGrid] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const pageSize = 20;

    // Hierarchy drill-down states
    const [officeCode, setOfficeCode] = useState(code);
    const [circleCode, setCircleCode] = useState('');
    const [selectedDivision, setSelectedDivision] = useState('');
    const [selectedSubDivision, setSelectedSubDivision] = useState('');
    const [filteredCircles, setFilteredCircles] = useState([]);
    const [filteredDivisions, setFilteredDivisions] = useState([]);
    const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
    const [subDivisions, setSubDivisions] = useState(
        JSON.parse(window.localStorage.getItem('subDivisions')) || []
    );

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const [dateFrom, setDateFrom] = useState(getCurrentDate());
    const [dateTo, setDateTo] = useState(getCurrentDate());
    const [escalationFilter, setEscalationFilter] = useState('all'); // 'all', 'SDO', 'SE', 'XEN'
    const [statusFilter, setStatusFilter] = useState('all'); // 'all', 'Pending', 'Allocated', 'OnHold', 'Resolved', 'Working'

    const getCompanies = (code) => {
        const companies = {
            '10': 'Power Information Technology Company',
            '11': 'Lahore Electric Supply Company',
            '12': 'Gujranwala Electric Power Company',
            '13': 'Faisalabad Electric Supply Company',
            '14': 'Islamabad Electric Supply Company',
            '15': 'Multan Electric Power Company',
            '26': 'Peshawar Electric Supply Company',
            '27': 'Hazara Electric Supply Company',
            '37': 'Hyderabad Electric Supply Company',
            '38': 'Sukkur Electric Power Company',
            '48': 'Quetta Electric Supply Company',
            '59': 'Tribal Electric Supply Company',
        };
        return companies[code] || '';
    };

    const getCompanyAbbr = (code) => {
        const abbr = {
            '10': 'PITC',
            '11': 'LESCO',
            '12': 'GEPCO',
            '13': 'FESCO',
            '14': 'IESCO',
            '15': 'MEPCO',
            '26': 'PESCO',
            '27': 'HAZECO',
            '37': 'HESCO',
            '38': 'SEPCO',
            '48': 'QESCO',
            '59': 'TESCO',
        };
        return abbr[code] || '';
    };

    const getLogo = (code) => {
        const logos = {
            '10': pitcLogo, '11': LESCOLOGO, '12': GEPCOLOGO, '13': FESCOLOGO,
            '14': IESCOLOGO, '15': MEPCOLOGO, '26': PESCOLOGO, '27': HAZECOLOGO,
            '37': HESCOLOGO, '38': SEPCOLOGO, '48': QESCOLOGO, '59': TESCOLOGO,
        };
        return logos[code] || MEPCOLOGO;
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}`;
    };

    const fetchAPMSComplaints = async () => {
        setViewBackdrop(true);
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                pageNumber: String(pageNumber),
                pageSize: String(pageSize),
                officeCode: String(officeCode),
                dateFrom: dateFrom,
                dateTo: dateTo,
                status: ""
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            const response = await fetch(cfpBaseUrl + "apms/getAllAPMSComplaint", requestOptions);
            const result = await response.json();

            console.log("API Response:", result);

            // Handle different response formats
            let complaintsData = [];
            let records = 0;
            let pages = 1;

            if (Array.isArray(result)) {
                // Response is array directly
                complaintsData = result;
                records = result.length;
                pages = Math.ceil(result.length / pageSize) || 1;
            } else if (result.status === "200" || result.status === 200) {
                // Wrapped response with status
                complaintsData = result.data || result.complaints || [];
                records = result.totalRecords || complaintsData.length;
                pages = result.totalPages || Math.ceil(records / pageSize) || 1;
            } else if (result.data) {
                // Has data property without status check
                complaintsData = Array.isArray(result.data) ? result.data : [];
                records = result.totalRecords || complaintsData.length;
                pages = result.totalPages || Math.ceil(records / pageSize) || 1;
            } else if (result.complaints) {
                // Has complaints property
                complaintsData = Array.isArray(result.complaints) ? result.complaints : [];
                records = result.totalRecords || complaintsData.length;
                pages = result.totalPages || Math.ceil(records / pageSize) || 1;
            }

            setApmsComplaints(complaintsData);
            setTotalRecords(records);
            setTotalPages(pages);
        } catch (error) {
            console.error("Error fetching APMS complaints:", error);
            setApmsComplaints([]);
        }
        setViewBackdrop(false);
    };

    const convertToDataGrid = () => {
        // Apply status filter
        let filteredComplaints = apmsComplaints;
        if (statusFilter !== 'all') {
            filteredComplaints = filteredComplaints.filter(item => item.status === statusFilter);
        }

        // Apply escalation filter
        if (escalationFilter === 'SDO') {
            filteredComplaints = filteredComplaints.filter(item => item.escalatedTo === 'SDO');
        } else if (escalationFilter === 'SE') {
            filteredComplaints = filteredComplaints.filter(item => item.escalatedTo === 'SE');
        } else if (escalationFilter === 'XEN') {
            filteredComplaints = filteredComplaints.filter(item => item.escalatedTo === 'XEN');
        }

        const tempArray = filteredComplaints.map((item, index) => ({
            srNo: ((pageNumber - 1) * pageSize) + index + 1,
            trackingId: item.eOpsTrackingId || '-',
            ccmsTrackingId: item.ticketNo || '-',
            referenceNumber : item.referenceNo,
            meterSerialNo: item.apmsMeterSerialNo || '-',
            complaintCategoryName: item.complaintCategoryName || '-',
            complaintTypeName: item.complaintTypeName || '-',
            transformerName: item.transformerName || '-',
            feederName: item.feederName || '-',
            source: item.source || '-',
            status: item.status || '-',
            registeredBy: item.registeredBy || '-',
            registeredAt: formatDate(item.registeredAt),
            modifiedBy: item.modifiedBy || '-',
            allocatedAt: formatDate(item.allocatedAt),
            linemanRemarks: item.linemanRemarks || '-',
            subDivisionCode: item.subDivisionCode || '-',
            latitude: item.transformerMeterLatitude,
            longitude: item.transformerMetering_Logitude,
            isEscalated: item.isEscalated ? 'Yes' : 'No',
            escalatedTo: item.escalatedTo || '-',
            rawData: item
        }));
        setDataGrid(tempArray);
    };

    useEffect(() => {
        fetchAPMSComplaints();
    }, [pageNumber]);

    useEffect(() => {
        convertToDataGrid();
    }, [apmsComplaints, escalationFilter, statusFilter, pageNumber]);

    // Initialize hierarchy dropdowns from localStorage based on user's level
    useEffect(() => {
        if (subDivisions && subDivisions.length > 0) {
            // Get circles
            const circles = subDivisions.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                    acc.push({
                        circleCode: curr.circleCode,
                        circleName: curr.circleName,
                        companyCode: curr.companyCode,
                    });
                }
                return acc;
            }, []);
            setFilteredCircles(circles);

            // For Division level users (hierarchy > 2), pre-populate divisions
            if (hierarchy > 2) {
                const userCircleCode = parseInt(String(code).substring(0, 3));
                const uniqueDivisions = subDivisions
                    .filter((item) => String(item.circleCode) === String(userCircleCode) || String(item.divisionCode).startsWith(String(code).substring(0, 3)))
                    .reduce((acc, item) => {
                        if (!acc.some((division) => division.divisionCode === item.divisionCode)) {
                            acc.push({
                                divisionCode: item.divisionCode,
                                divisionName: item.divisionName,
                                companyCode: item.companyCode,
                            });
                        }
                        return acc;
                    }, []);
                setFilteredDivisions(uniqueDivisions);
            }

            // For Subdivision level users (hierarchy > 3), pre-populate subdivisions
            if (hierarchy > 3) {
                const userDivisionCode = parseInt(String(code).substring(0, 4));
                const uniqueSubDivisions = subDivisions
                    .filter((item) => String(item.divisionCode) === String(userDivisionCode) || String(item.subDivisionCode).startsWith(String(code).substring(0, 4)))
                    .reduce((acc, item) => {
                        if (!acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)) {
                            acc.push({
                                subDivisionCode: item.subDivisionCode,
                                subDivisionName: item.subDivisionName,
                                companyCode: item.companyCode,
                            });
                        }
                        return acc;
                    }, []);
                setFilteredSubDivisions(uniqueSubDivisions);
            }
        }
    }, [subDivisions, hierarchy, code]);

    // Circle change handler
    const handleCircleChange = (e) => {
        const selectedCircleCode = e.target.value ? parseInt(e.target.value) : '';
        setCircleCode(selectedCircleCode);
        setSelectedDivision('');
        setSelectedSubDivision('');
        setFilteredSubDivisions([]);

        if (selectedCircleCode) {
            setOfficeCode(selectedCircleCode);
            // Filter divisions for selected circle
            const uniqueDivisions = subDivisions
                .filter((item) => item.circleCode === selectedCircleCode)
                .reduce((acc, item) => {
                    if (!acc.some((division) => division.divisionCode === item.divisionCode)) {
                        acc.push({
                            divisionCode: item.divisionCode,
                            divisionName: item.divisionName,
                            companyCode: item.companyCode,
                        });
                    }
                    return acc;
                }, []);
            setFilteredDivisions(uniqueDivisions);
        } else {
            setOfficeCode(code);
            setFilteredDivisions([]);
        }
    };

    // Division change handler
    const handleDivisionChange = (e) => {
        const selectedDivisionCode = e.target.value ? parseInt(e.target.value) : '';
        setSelectedDivision(selectedDivisionCode);
        setSelectedSubDivision('');

        if (selectedDivisionCode) {
            setOfficeCode(selectedDivisionCode);
            // Filter subdivisions for selected division
            const uniqueSubDivisions = subDivisions
                .filter((item) => item.divisionCode === selectedDivisionCode)
                .reduce((acc, item) => {
                    if (!acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)) {
                        acc.push({
                            subDivisionCode: item.subDivisionCode,
                            subDivisionName: item.subDivisionName,
                            companyCode: item.companyCode,
                        });
                    }
                    return acc;
                }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
        } else {
            setOfficeCode(circleCode || code);
            setFilteredSubDivisions([]);
        }
    };

    // Subdivision change handler
    const handleSubDivisionChange = (e) => {
        const selectedSubDivisionCode = e.target.value ? parseInt(e.target.value) : '';
        setSelectedSubDivision(selectedSubDivisionCode);

        if (selectedSubDivisionCode) {
            setOfficeCode(selectedSubDivisionCode);
        } else {
            setOfficeCode(selectedDivision || circleCode || code);
        }
    };

    const handleGo = () => {
        setPageNumber(1);
        fetchAPMSComplaints();
    };

    const handleNextPage = () => {
        if (pageNumber < totalPages) {
            setPageNumber(pageNumber + 1);
        }
    };

    const handlePreviousPage = () => {
        if (pageNumber > 1) {
            setPageNumber(pageNumber - 1);
        }
    };

    const handleFirstPage = () => {
        setPageNumber(1);
    };

    const handleLastPage = () => {
        setPageNumber(totalPages);
    };

    const handleRowClick = (row) => {
        console.log('Row clicked:', row);
    };

    // Export to Excel
    const exportToExcel = () => {
        const exportData = dataGrid.map(({ rawData, ...rest }) => rest);
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "APMS Complaints");
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(data, `APMS_Complaints_${getCurrentDate()}.xlsx`);
    };

    // Export to PDF
    const exportToPDF = () => {
        const doc = new jsPDF('landscape');
        const pageWidth = doc.internal.pageSize.getWidth();
        const padding = 10;

        doc.addImage(getLogo(companyCode), "PNG", padding, 5, 25, 15);
        doc.addImage(eOpsLogo, "PNG", pageWidth - padding - 25, 5, 25, 15);
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text(getCompanies(companyCode), pageWidth / 2, 15, { align: "center" });
        doc.setFontSize(12);
        doc.text("APMS Complaints Report", pageWidth / 2, 22, { align: "center" });
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text(`Date: ${dateFrom || 'All'} to ${dateTo}`, pageWidth / 2, 28, { align: "center" });

        const tableData = dataGrid.map(item => [
            item.srNo,
            item.trackingId,
            item.ccmsTrackingId,
            item.referenceNumber,
            item.meterSerialNo,
            item.complaintCategoryName,
            item.complaintTypeName,
            item.status,
            item.registeredAt,
            item.linemanRemarks
        ]);

        doc.autoTable({
            head: [['Sr.', 'Tracking ID', 'CCMS Ticket No', 'Reference No', 'Meter No.', 'Category', 'Type', 'Status', 'Registered At', 'Remarks']],
            body: tableData,
            startY: 35,
            styles: { fontSize: 8 },
            headStyles: { fillColor: [0, 57, 113] }
        });

        doc.save(`APMS_Complaints_${getCurrentDate()}.pdf`);
    };

    // Calculate stats
    const pendingCount = apmsComplaints.filter(c => c.status === 'Pending').length;
    const workingCount = apmsComplaints.filter(c => c.status === 'Working').length;
    const resolvedCount = apmsComplaints.filter(c => c.status === 'Resolved').length;
    const sdoCount = apmsComplaints.filter(c => c.escalatedTo === 'SDO').length;
    const seCount = apmsComplaints.filter(c => c.escalatedTo === 'SE').length;
    const xenCount = apmsComplaints.filter(c => c.escalatedTo === 'XEN').length;

    // Table column definitions
    const tblColumns = [
        { field: "srNo", headerName: 'Sr No', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '50px', maxWidth: '60px' } },
        { field: "trackingId", headerName: 'Complaint ID', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '130px', maxWidth: '150px', color: '#006ad1', fontWeight: '600' } },
        { field: "ccmsTrackingId", headerName: 'CCMS Ticket No', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '130px', maxWidth: '150px', color: '#006ad1', fontWeight: '600' } },
        { field: "referenceNumber", headerName: 'Reference Number', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '130px', maxWidth: '150px', color: '#006ad1', fontWeight: '600' } },

        { field: "meterSerialNo", headerName: 'Meter No', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "complaintCategoryName", headerName: 'Category', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "complaintTypeName", headerName: 'Type', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "transformerName", headerName: 'Transformer', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '150px', maxWidth: '180px' } },
        { field: "source", headerName: 'Source', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '70px', maxWidth: '80px' } },
        {
            field: "status", headerName: 'Status', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '90px', maxWidth: '100px' },
            renderCell: (row) => (
                <span style={{
                    backgroundColor: row.status === 'Resolved' ? '#28a745' :
                        row.status === 'Pending' ? '#ffc107' :
                            row.status === 'Working' ? '#17a2b8' :
                                row.status === 'Allocated' ? '#007bff' : '#6c757d',
                    color: row.status === 'Pending' ? '#000' : 'white',
                    padding: '4px 10px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    fontWeight: 'bold'
                }}>
                    {row.status}
                </span>
            )
        },
        {
            field: "escalatedTo", headerName: 'Escalated To', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '90px', maxWidth: '100px' },
            renderCell: (row) => (
                <span style={{
                    backgroundColor: row.escalatedTo === 'SDO' ? '#fd7e14' :
                        row.escalatedTo === 'SE' ? '#dc3545' :
                            row.escalatedTo === 'XEN' ? '#6f42c1' : '#6c757d',
                    color: 'white',
                    padding: '4px 10px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    fontWeight: 'bold'
                }}>
                    {row.escalatedTo}
                </span>
            )
        },
        { field: "registeredAt", headerName: 'Registered At', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '120px', maxWidth: '140px' } },
        { field: "linemanRemarks", headerName: 'Remarks', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, minWidth: '100px', maxWidth: '150px' } },
    ];

    return (
        <div style={{ marginTop: '4rem', height: 'calc(100vh - 4rem)', display: 'flex', flexDirection: 'column', overflow: 'hidden', backgroundColor: '#fff' }}>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={viewBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>

            {/* Header */}
            <div style={{ padding: '8px 15px', backgroundColor: '#f5f5f5', borderBottom: '1px solid #ddd', flexShrink: 0 }}>
                {/* Title Row */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <Typography variant="h6" style={{ color: '#003971', fontSize: '22px' }}>
                        APMS Escalated Complaints
                    </Typography>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <img src={excel} alt="Excel" style={{ ...internalIconStyles, width: '22px', height: '22px', cursor: 'pointer' }} onClick={exportToExcel} title="Export to Excel" />
                        <img src={pdf} alt="PDF" style={{ ...internalIconStyles, width: '22px', height: '22px', cursor: 'pointer' }} onClick={exportToPDF} title="Export to PDF" />
                    </div>
                </div>

                {/* Filters Row */}
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                    {/* Circle Dropdown */}
                    {hierarchy <= 2 && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <label style={{ fontSize: '13px', fontWeight: 'bold' }}>Circle:</label>
                            <select
                                value={circleCode || ''}
                                onChange={handleCircleChange}
                                style={{ padding: '5px 8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '13px', minWidth: '120px' }}
                            >
                                <option value="">All Circles</option>
                                {filteredCircles.map((circle) => (
                                    <option key={circle.circleCode} value={circle.circleCode}>
                                        {circle.circleName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {/* Division Dropdown */}
                    {hierarchy <= 3 && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <label style={{ fontSize: '13px', fontWeight: 'bold' }}>Division:</label>
                            <select
                                value={selectedDivision || ''}
                                onChange={handleDivisionChange}
                                disabled={hierarchy <= 2 && !circleCode}
                                style={{ padding: '5px 8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '13px', minWidth: '120px', backgroundColor: (hierarchy <= 2 && !circleCode) ? '#f0f0f0' : 'white' }}
                            >
                                <option value="">All Divisions</option>
                                {filteredDivisions.map((division) => (
                                    <option key={division.divisionCode} value={division.divisionCode}>
                                        {division.divisionName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {/* Subdivision Dropdown */}
                    {hierarchy <= 4 && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <label style={{ fontSize: '13px', fontWeight: 'bold' }}>Sub-Division:</label>
                            <select
                                value={selectedSubDivision || ''}
                                onChange={handleSubDivisionChange}
                                disabled={hierarchy <= 3 && !selectedDivision}
                                style={{ padding: '5px 8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '13px', minWidth: '120px', backgroundColor: (hierarchy <= 3 && !selectedDivision) ? '#f0f0f0' : 'white' }}
                            >
                                <option value="">All Sub-Divisions</option>
                                {filteredSubDivisions.map((subDivision) => (
                                    <option key={subDivision.subDivisionCode} value={subDivision.subDivisionCode}>
                                        {subDivision.subDivisionName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <label style={{ fontSize: '13px', fontWeight: 'bold' }}>From:</label>
                        <input
                            type="date"
                            value={dateFrom}
                            onChange={(e) => setDateFrom(e.target.value)}
                            style={{ padding: '5px 8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '13px' }}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <label style={{ fontSize: '13px', fontWeight: 'bold' }}>To:</label>
                        <input
                            type="date"
                            value={dateTo}
                            onChange={(e) => setDateTo(e.target.value)}
                            style={{ padding: '5px 8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '13px' }}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <label style={{ fontSize: '13px', fontWeight: 'bold' }}>Status:</label>
                        <select
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            style={{ padding: '5px 8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '13px', minWidth: '100px' }}
                        >
                            <option value="all">All</option>
                            <option value="Pending">Pending</option>
                            <option value="Allocated">Allocated</option>
                            <option value="Working">Working</option>
                            <option value="OnHold">OnHold</option>
                            <option value="Resolved">Resolved</option>

                        </select>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <label style={{ fontSize: '13px', fontWeight: 'bold' }}>Escalated To:</label>
                        <select
                            value={escalationFilter}
                            onChange={(e) => setEscalationFilter(e.target.value)}
                            style={{ padding: '5px 8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '13px', minWidth: '100px' }}
                        >
                            <option value="all">All</option>
                            <option value="SDO">SDO</option>
                            <option value="SE">SE</option>
                            <option value="XEN">XEN</option>
                        </select>
                    </div>
                    <Button
                        variant="contained"
                        onClick={handleGo}
                        size="small"
                        style={{ backgroundColor: '#003971', color: 'white', fontSize: '13px', padding: '5px 20px' }}
                    >
                        GO
                    </Button>

                    {/* Stats inline */}
                    <div style={{ display: 'flex', gap: '8px', marginLeft: 'auto', flexWrap: 'wrap' }}>
                        <span style={{ fontSize: '12px', padding: '4px 8px', backgroundColor: '#ffc107', borderRadius: '4px', fontWeight: 'bold' }}>
                            Pending: {pendingCount}
                        </span>
                        <span style={{ fontSize: '12px', padding: '4px 8px', backgroundColor: '#17a2b8', color: 'white', borderRadius: '4px', fontWeight: 'bold' }}>
                            Working: {workingCount}
                        </span>
                        <span style={{ fontSize: '12px', padding: '4px 8px', backgroundColor: '#28a745', color: 'white', borderRadius: '4px', fontWeight: 'bold' }}>
                            Resolved: {resolvedCount}
                        </span>
                        <span style={{ fontSize: '12px', padding: '4px 8px', backgroundColor: '#fd7e14', color: 'white', borderRadius: '4px', fontWeight: 'bold' }}>
                            SDO: {sdoCount}
                        </span>
                        <span style={{ fontSize: '12px', padding: '4px 8px', backgroundColor: '#dc3545', color: 'white', borderRadius: '4px', fontWeight: 'bold' }}>
                            SE: {seCount}
                        </span>
                        <span style={{ fontSize: '12px', padding: '4px 8px', backgroundColor: '#6f42c1', color: 'white', borderRadius: '4px', fontWeight: 'bold' }}>
                            XEN: {xenCount}
                        </span>
                        <span style={{ fontSize: '12px', padding: '4px 8px', backgroundColor: '#003971', color: 'white', borderRadius: '4px', fontWeight: 'bold' }}>
                            Total: {totalRecords}
                        </span>
                    </div>
                </div>
            </div>

            {/* Main Content - Table */}
            <div style={{ flex: 1, padding: '8px 15px 10px 15px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                <h3 style={{ backgroundColor: '#006ad1', color: 'white', padding: '8px 15px', textAlign: 'center', fontWeight: 'bold', fontSize: '14px', margin: 0, flexShrink: 0 }}>
                    Daily APMS Escalated Complaints Report for ({getCompanyAbbr(companyCode)})
                </h3>
                <div style={{ flex: 1, overflow: 'auto', minHeight: 10 }}>
                    <div>
                        <BasicTable
                            data={dataGrid}
                            columns={tblColumns}
                            handleRowClick={(params) => { handleRowClick(params) }}
                            sx={tableStyle}
                            rowHeight={37.5}
                            pageSize={pageSize}
                            rowsPerPageOptions={[20, 50, 100]}
                            nextPage={handleNextPage}
                            firstPage={handleFirstPage}
                            lastPage={handleLastPage}
                            previousPage={handlePreviousPage}
                            totalPages={totalPages}
                            totalRecords={totalRecords}
                            currentPage={pageNumber}
                            rowsPageOption={false}
                            isLoading={viewBackdrop}
                            getRowStyle={(params) => {
                                return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default APMSEscalatedComplaints;
